var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAurigami(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 120",
    style: {
      enableBackground: "new 0 0 380 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#14C846;}\n\t.st1{fill:#A0E6AA;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.52,66.31c0,2.35-0.58,4.16-1.75,5.43c-1.17,1.27-2.78,1.9-4.83,1.9c-2.02,0-3.61-0.63-4.77-1.9 c-1.17-1.27-1.75-3.07-1.75-5.43V50H144v17.38c0,2.64,0.5,4.91,1.51,6.82c1.01,1.91,2.39,3.35,4.16,4.33s3.8,1.47,6.1,1.47 c1.8,0,3.47-0.37,5.01-1.1c1.54-0.73,2.78-1.74,3.74-3.02v3.74H172V50h-7.48V66.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.68,55.02v-4.59H179V80h7.68V65.27c0-2.74,0.61-4.66,1.84-5.77c1.22-1.1,3.04-1.65,5.46-1.65H196V50 c-2.05,0-3.87,0.45-5.46,1.33C188.95,52.22,187.66,53.45,186.68,55.02z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 50,
    className: "st0",
    width: 7.5,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.78,54.21c-0.86-1.24-2.03-2.26-3.53-3.04c-1.49-0.78-3.23-1.17-5.2-1.17c-2.26,0-4.3,0.56-6.12,1.68 c-1.83,1.12-3.27,2.71-4.34,4.78c-1.06,2.07-1.6,4.45-1.6,7.13c0,2.71,0.53,5.11,1.6,7.2c1.06,2.09,2.52,3.71,4.36,4.86 c1.84,1.15,3.88,1.72,6.1,1.72c1.94,0,3.66-0.42,5.17-1.24c1.51-0.83,2.69-1.87,3.55-3.11v4.11c0,2.36-0.6,4.12-1.81,5.29 c-1.21,1.16-2.78,1.75-4.72,1.75c-1.65,0-3.06-0.36-4.22-1.08c-1.16-0.72-1.91-1.68-2.26-2.89h-6.63 c0.32,3.03,1.68,5.42,4.08,7.18c2.4,1.75,5.47,2.63,9.22,2.63c2.8,0,5.18-0.57,7.15-1.7c1.97-1.13,3.45-2.66,4.43-4.59 c0.98-1.93,1.48-4.12,1.48-6.58v-26.7h-6.72V54.21z M235.83,67.87c-0.64,1.16-1.49,2.06-2.57,2.68c-1.08,0.62-2.24,0.93-3.48,0.93 c-1.21,0-2.34-0.32-3.41-0.96c-1.06-0.64-1.92-1.56-2.57-2.75c-0.65-1.2-0.98-2.59-0.98-4.19c0-1.59,0.33-2.97,0.98-4.14 c0.65-1.16,1.5-2.05,2.55-2.66c1.05-0.61,2.19-0.91,3.43-0.91c1.24,0,2.4,0.31,3.48,0.93c1.08,0.62,1.94,1.52,2.57,2.68 c0.64,1.17,0.95,2.56,0.95,4.19C236.78,65.31,236.46,66.71,235.83,67.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.17,54.62c-0.97-1.33-2.26-2.43-3.87-3.3c-1.61-0.87-3.49-1.31-5.64-1.31c-2.46,0-4.69,0.61-6.68,1.84 c-1.99,1.22-3.57,2.97-4.73,5.24c-1.16,2.27-1.74,4.88-1.74,7.82c0,2.97,0.58,5.6,1.74,7.89c1.16,2.29,2.74,4.06,4.73,5.32 c1.99,1.26,4.2,1.89,6.63,1.89c2.15,0,4.05-0.45,5.69-1.34c1.65-0.89,2.94-2.02,3.87-3.38v4.25h7.33V50.47h-7.33V54.62z  M270.13,69.59c-0.69,1.28-1.63,2.26-2.81,2.94c-1.18,0.68-2.44,1.02-3.8,1.02c-1.32,0-2.56-0.35-3.72-1.05 c-1.16-0.7-2.1-1.7-2.81-3.01c-0.71-1.31-1.07-2.84-1.07-4.59c0-1.75,0.36-3.26,1.07-4.54c0.71-1.28,1.64-2.25,2.78-2.91 c1.14-0.66,2.39-1,3.74-1c1.35,0,2.62,0.34,3.8,1.02c1.18,0.68,2.11,1.66,2.81,2.94c0.69,1.28,1.04,2.81,1.04,4.59 C271.17,66.78,270.82,68.31,270.13,69.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.34,50c-2.14,0-4.13,0.52-5.97,1.55c-1.84,1.03-3.24,2.4-4.2,4.11c-1-1.82-2.41-3.21-4.23-4.19 c-1.82-0.98-3.89-1.47-6.21-1.47c-1.82,0-3.49,0.36-5.01,1.07c-1.52,0.71-2.76,1.69-3.72,2.94v-3.58h-7.5V80h7.5V63.66 c0-2.31,0.6-4.08,1.79-5.31c1.2-1.23,2.83-1.84,4.9-1.84c2.04,0,3.64,0.61,4.82,1.84s1.77,3,1.77,5.31V80h7.5V63.66 c0-2.31,0.6-4.08,1.79-5.31c1.2-1.23,2.81-1.84,4.85-1.84c2.04,0,3.64,0.61,4.82,1.84c1.18,1.23,1.77,3,1.77,5.31V80h7.5V62.65 c0-3.99-1.12-7.09-3.35-9.32C328.92,51.11,325.99,50,322.34,50z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.25,
    y: 50,
    className: "st0",
    width: 7.5,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115.1,40 100,80 108.84,80 119.97,49.27 131.1,80 140,80 124.9,40  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.25,35c-1.43,0-2.63,0.48-3.58,1.43c-0.95,0.96-1.42,2.14-1.42,3.57c0,1.42,0.47,2.61,1.42,3.57 c0.95,0.96,2.14,1.43,3.58,1.43c1.43,0,2.62-0.48,3.58-1.43c0.95-0.95,1.42-2.14,1.42-3.57c0-1.42-0.48-2.61-1.42-3.57 C208.87,35.48,207.68,35,206.25,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345,45c1.43,0,2.62-0.48,3.58-1.43c0.95-0.95,1.42-2.14,1.42-3.57c0-1.42-0.48-2.61-1.42-3.57 C347.63,35.48,346.43,35,345,35c-1.43,0-2.63,0.48-3.58,1.43C340.47,37.39,340,38.58,340,40c0,1.42,0.47,2.61,1.42,3.57 C342.37,44.52,343.57,45,345,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.18,62.06l0.34,0.73l-12.22-26.2c-0.39-0.83-1-0.82-1.37,0.02l-7.43,17.1l-0.48,1.09l19.51,7.72 C88.96,63.08,89.81,63.41,89.18,62.06z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "89.3,63.78 89.3,63.78 78.07,71.67  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.52,62.8l-0.34-0.73c0.63,1.34-0.22,1.02-1.64,0.46L68.03,54.8l0,0L37.48,42.71 c-0.85-0.34-1.29,0.09-0.98,0.95l8.87,24.37l7.37,20.25c0.18,0.51,0.7,0.67,1.14,0.36l24.2-16.98l11.23-7.88 c0.28-0.2,0.4-0.62,0.25-0.93L89.52,62.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 60,
    cy: 60,
    r: 30
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurigami);
export default __webpack_public_path__ + "static/media/aurigami.1ebfa02ed48c53781e39e3dc0eaf8537.svg";
export { ForwardRef as ReactComponent };